// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderLogo_link__ddG5f","logo":"HeaderLogo_logo__t7Dhu"};